module.exports = __webpack_public_path__ + "img/meet.ca54599b.jpg";